import { render, staticRenderFns } from "./CalendarBase.vue?vue&type=template&id=6a878a31&scoped=true"
import script from "./CalendarBase.vue?vue&type=script&lang=ts"
export * from "./CalendarBase.vue?vue&type=script&lang=ts"
import style0 from "./CalendarBase.vue?vue&type=style&index=0&id=6a878a31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a878a31",
  null
  
)

export default component.exports